import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton, Button, Container, Grid } from '@mui/material';

import Navbar from '../components/Navbar';
import Cuisin from './CuisinPage/Cuisin';
import CuisinTwo from './CuisinPage/CuisinTwo';
import CuisinThree from './CuisinPage/CuisinThree';

function About() {
    const [bgIndex, setBgIndex] = useState(0);



    return (
        <>
            <Navbar />
            <Box>

                <Cuisin />
                <CuisinTwo/>
                <CuisinThree/>


            </Box>
        </>
    );
}

export default About;
